import { Component, Input } from '@angular/core';
import { KpiCategories, KpisByKey, MilestoneName } from '@models';

@Component({
  selector: 'kpis-card-view',
  templateUrl: './kpis-card-view.component.html',
  styleUrl: './kpis-card-view.component.scss'
})
export class KpisCardViewComponent {
  @Input() kpisByCategory!: { category: KpiCategories; kpis: KpisByKey }[];
  @Input() keyMilestones?: MilestoneName[];
}
